import { ProtectedRoute } from "../utils/ProtectedRoute";
import DiaryPage from "./DiaryPage";
import { privateNavigationLinks } from "../utils/navigationLinks";
import NavbarScroller from "./Navbar";
import { Link } from "react-router-dom";
import DiaryEntries from "./DiaryEntries";
import { useDispatch, useSelector } from "react-redux";
import { clearDiaryState } from "../features/Diary/DiarySlice";
import { Tooltip } from "@mui/material";
import add_habit from "../styles/utils/add_circle.svg";
import "../styles/components/add-diary-entry.scss";
import { RootState } from "../app/store";
import { useEffect } from "react";

const Diary = (props: { links: Array<{ name: string; to: string }> }) => {
  interface IDiary {
    entry_id: number;
    entry_title: string;
    entry: string;
    entry_date: string;
  }

  const emptyDiaryEntry: IDiary = {
    entry: "",
    entry_date: "",
    entry_id: -999,
    entry_title: "",
  };
  const dispatch = useDispatch();
  const { isDiaryFetching } = useSelector((state: RootState) => state.diary);

  useEffect(() => {
    console.log(isDiaryFetching);
  }, [isDiaryFetching]);

  return (
    <>
      <NavbarScroller links={privateNavigationLinks.links} />
      <div>
        <div className="add-diary-entry">
          <Tooltip title="Create new diary entry" placement="top">
            <div
              className="add-diary-button-area"
              onClick={() => dispatch(clearDiaryState())}
            >
              <Link
                to={{
                  pathname: "/diary-new-entry",
                  state: emptyDiaryEntry,
                }}
                className="link"
                onClick={() => dispatch(clearDiaryState())}
              >
                <img
                  src={add_habit}
                  alt="Add Habit Icon"
                  style={{ width: "50px", height: "50px" }}
                  className="add-habit--button"
                />
                <p>Create a new diary entry</p>
              </Link>
            </div>
          </Tooltip>
        </div>
      </div>
      <ProtectedRoute exact component={DiaryPage} path="/diary-new-entry" />
      <DiaryEntries />
    </>
  );
};

export default Diary;
